import { SET_AIR_SEARCH_REQUEST } from '../../actions/actionTypes'

const airSearchReq = (state = {}, action) => {
  switch (action.type) {
    case SET_AIR_SEARCH_REQUEST:
      return action.searchRequest
    default:
      return state
  }
}

export { airSearchReq }
